<template>
    <InformeCard id="venta_online_agrupada" name="venta_online_agrupada" collapsable="true" title="Venta online agrupada">
        <div class="table-responsive">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th>TIPO DE PRECIO</th>
                        <th>MÉTODO DE PAGO</th>
                        <th>LOCALIZACIÓN</th>
                        <th>PRECIO</th>
                        <th>VENDIDAS</th>
                        <th>TOTAL</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(venta, index) in venta_anticipada">
                        <tr :key="index">
                            <td>{{ venta.description ?? venta.description_plaza }}</td>
                            <td>{{ venta.metodo_pago | formatear_metodo_pago_entrada }}</td>
                            <td>{{ venta.place_section_name || venta.place_section_plaza_name || venta.region_name || venta.region_plaza_name || venta.sector_name || '' }}</td>
                            <td>{{ venta.price | formatear_precio }}</td>
                            <td>{{ venta.total }}</td>
                            <td>{{ venta.price * venta.total | formatear_precio }}</td>
                        </tr>
                    </template>
                    <tr>
                        <td colspan="4">TOTAL</td>
                        <td>{{ getTotalVendidas() }}</td>
                        <td>{{ getRecaudacionTotal() | formatear_precio }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['event_id', 'informe'],
        computed: {
            venta_anticipada : function() {
                if(this.informe) {
                    var informe = this.informe.filter(function(v, i) {
                        return v.taquilla == 0 && (v.metodo_pago == 0 || v.metodo_pago == 4 || v.metodo_pago == 8);
                    });

                    return informe;
                }
                return null;
            },
        },
        methods: {
            getTotalVendidas() {
                var total = 0;
                for (var i = 0; i < this.venta_anticipada.length; i++) {
                    total = total + this.venta_anticipada[i].total;
                }

                this.$emit('totalVentas', total);

                return total;
            },
            getRecaudacionTotal() {
                var total = 0;
                for (var i = 0; i < this.venta_anticipada.length; i++) {
                    var rec = this.venta_anticipada[i].total * this.venta_anticipada[i].price
                    total = total + rec;
                }

                return total;
            }
        },
        components: {
            InformeCard,
        }
    }
</script>
